import { createReducer, on } from '@ngrx/store';
import { SORActions } from './sor.actions';
import { SORItem } from '@core/interface/sor';
import { Pagination } from '@core/interface/core';

export const SORFeatureKey = 'SOR';

export interface SORState {
  SORs: SORItem[];
  isLoading: boolean;
  loadError?: any;
  deleteError?: any;
  addEditError?: any;
  isDeleted: boolean;
  pagination: Pagination;
}

export const initialState: SORState = {
  SORs: [],
  isLoading: false,
  isDeleted: false,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 100,
  },
};

export const SORReducer = createReducer(
  initialState,
  on(SORActions.loadSORs, (state) => ({
    ...state,
    isDeleted: false,
    loadError: null,
    isLoading: true,
  })),
  on(SORActions.loadSORsSuccess, (state, { data, pagination }) => ({
    ...state,
    SORs: data,
    isLoading: false,
    isDeleted: false,
    loadError: null,
    pagination,
  })),
  on(SORActions.loadSORsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    isDeleted: false,
    loadError: error,
  })),
  on(SORActions.addSORSuccess, (state, { data }) => ({
    ...state,
    SORs: [...state.SORs, data],
    isDeleted: false,
    addEditError: null,
  })),
  on(SORActions.addSORFailure, (state, { error }) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(SORActions.updateSORSuccess, (state, { data }) => ({
    ...state,
    SORs: state.SORs.map((SOR) => (data.id == SOR.id ? data : SOR)),
    isDeleted: false,
    addEditError: null,
  })),
  on(SORActions.updateSORFailure, (state, { error }) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(SORActions.deleteSORSuccess, (state, { success, id }) => {
    return {
      ...state,
      isDeleted: success,
      deleteError: null,
      SORs: state.SORs.filter((SOR) => SOR.id !== id),
    };
  }),
  on(SORActions.deleteSORFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: error,
  })),
  on(SORActions.deleteSOR, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: null,
  })),
  on(SORActions.resetDeleteStatus, (state) => ({
    ...state,
    isDeleted: false,
  })),
  on(SORActions.resetSORs, (state) => ({
    ...state,
    SORs: [],
  }))
);
